import * as React from "react"

import { Footer as NiftoryFooter } from "../shell/Footer/Footer"
import { footerLinks } from "./_footerData"

export const Footer = () => <NiftoryFooter links={footerLinks} />
